export default {
  init() {
    // JavaScript to be fired on the services page
    $(document).ready(function(){
      $('.services-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay:true,
        speed: 3000,
        slidesToShow: 1,
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the services page, after the init JS
  },
};
